import { Swiss } from "model/Tournament/Segment/Swiss/Swiss";
import { selectCompletedMatches } from "selectors/Match";
import { HeaderRow, HighlightTh, Table } from "../styles";
import { SwissTableRow } from "./SwissTableRow";
import { calculateNonSetSwissRecords } from "model/Records old/CupModeSwissRecord";
import { useAppSelector } from "app/hooks";

interface Props {
  swiss: Swiss;
  rosterIds: string[];
  tournamentId: string;
}

// todo - this code kinda sucks
export const SwissTable = ({ swiss, rosterIds, tournamentId }: Props) => {
  const matches = useAppSelector((state) =>
    selectCompletedMatches(
      state,
      swiss.rounds.flatMap((r) => r.matchIds)
    )
  );

  const records = calculateNonSetSwissRecords(rosterIds, swiss.rounds, matches);
  return (
    <Table>
      <HeaderRow>
        <th colSpan={3} />
        <HighlightTh title="Match Record">W - L</HighlightTh>
        {swiss.rounds.map((r) => (
          <th>Round {r.roundNum}</th>
        ))}
      </HeaderRow>
      {records.map((r) => (
        <SwissTableRow
          key={r.rosterId}
          tournamentId={tournamentId}
          record={r}
          numberOfRounds={swiss.rounds.length}
        />
      ))}
    </Table>
  );
};
